// Utilities
import { createSimpleFunctional } from '@/util'

export const VStepperHeader = createSimpleFunctional('v-stepper-header')

export type VStepperHeader = InstanceType<typeof VStepperHeader>
